import { Injectable } from "@angular/core";
import { AgentKey } from "../model/uchat.model";
import { AppConfigService } from "../app-config.service";
import { AgentDefinition } from "../model/agentDefinition";

/**
 * How the UI presents the chat agents.
 */
@Injectable({
    providedIn: 'root'
})
export class AgentCatalogueService  {
    constructor(
        private appConfigService:AppConfigService
    ){}

    /**
     * TODO: Consider putting this in a DB of some sort
     * @returns Collection of all the agents available
     */
    public getAgentCatalogue(){
        let agentCatalogue: AgentDefinition[] = [
        {
            key: "it_support_agent",
            label: "IT Support",
            accent: "it",
            icon: "bi-display",
            blurb: "Accounts & passwords, NSID, Wi-Fi, email, software, hardware",
            welcome: "I'm your **PAWS IT Digital Agent**, here to help with IT services and support — "
                + "NSID and passwords, Wi-Fi, email, Microsoft 365, software downloads and device help."
                + "\n\n**What can I help you with today?**",
            placeholder: "Ask about IT services — accounts, Wi-Fi, software ...",
            isNew: false,
            roles: this.appConfigService.getItAgentRoles()
        },
        {
            key: "student_support_agent",
            label: "Student Support",
            accent: "student",
            icon: "bi-mortarboard",
            blurb: "Registration, tuition & fees, awards, transcripts, advising",
            welcome: "I'm your **PAWS Student Digital Agent**. I can help with the academic and administrative "
                + "side of being a student — course registration, tuition and fees, awards and funding, "
                + "transcripts, deadlines and where to find your advisor."
                + "\n\n**What can I help you with today?**",
            placeholder: "Ask about registration, fees, awards, transcripts ...",
            isNew: true,
            roles: this.appConfigService.getStudentAgentRoles()
        }];
        return agentCatalogue;
    }
    public agentDefinition( key: AgentKey ): AgentDefinition | null {
        let found = this.getAgentCatalogue().find( (a: AgentDefinition) => a.key === key );
        return found === undefined ? null : found;
    }

    public agentLabel( key: AgentKey ): string {
        let found = this.agentDefinition(key);
        return found === null ? "PAWS Agent" : found.label;
    }
}

